module.exports = __webpack_public_path__ + "img/7.afadf65b.png";